<template>
  <section :class="['support-card', { 'support-card--compact': compact }]">
    <div class="support-card__header">
      <div>
        <p class="support-card__eyebrow">Rating</p>
        <h3 class="support-card__title">
          {{ canRating ? 'Tu calificacion' : 'Como calificas este contenido?' }}
        </h3>
      </div>
      <v-chip v-if="average" small class="support-card__chip">
        Promedio {{ average }}
      </v-chip>
    </div>

    <div class="rating-panel">
      <v-rating
        v-model="ratingModel"
        half-increments
        :readonly="canRating"
        background-color="#D9E2EA"
        color="#0DB2D2"
        large
      />
      <v-btn
        v-if="!canRating && ratingModel > 0"
        rounded
        depressed
        color="#0076ff"
        dark
        class="rating-panel__button"
        :loading="loading"
        @click="$emit('submit')"
      >
        <v-icon left>mdi-star-check</v-icon>
        Calificar
      </v-btn>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContentRating',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    average: {
      type: [Number, String],
      default: 0,
    },
    canRating: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ratingModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style scoped>
.support-card {
  width: 100%;
  background: #fff;
  border: 1px solid #eef2f6;
  border-radius: 8px;
  padding: 20px;
}

.support-card--compact {
  border: 0;
  border-radius: 8px;
}

.support-card__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
}

.support-card__eyebrow {
  margin: 0 0 2px;
  color: #8a98a5;
  font: normal normal 400 12px/18px Poppins;
}

.support-card__title {
  margin: 0;
  color: #101820;
  font: normal normal 700 18px/26px Poppins;
}

.support-card__chip {
  background: #f6f8fa !important;
  color: #607080;
}

.rating-panel {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.rating-panel__button {
  min-width: 136px;
  text-transform: none;
  font: normal normal 500 13px/22px Poppins;
}

@media (max-width: 600px) {
  .support-card {
    padding: 16px;
  }

  .rating-panel {
    justify-content: center;
  }

  .support-card__header {
    flex-direction: column;
  }
}
</style>
